import React, { useEffect, useRef } from "react";
import { useField } from "formik";

function TextInput({
    label = "Label",
    name,
    fieldType = "text",
    required = false,
    placeholder,
    onInputChange,
    errorStyles = {},
    ...props
}) {
    const [field, meta, helpers] = useField(name);
    const { setValue } = helpers;
    const inputRef = useRef(null);

    const handleInputClick = () => {
        if (
            inputRef.current &&
            (fieldType === "time" || fieldType === "date")
        ) {
            inputRef.current.showPicker?.();
        }
    };

    useEffect(() => {
        const value =
            typeof field?.value?.trimLeft === "function"
                ? field.value.trimLeft()
                : field.value;

        typeof onInputChange === "function" && onInputChange(value || "");
        setValue(value);
    }, [field.value, setValue]);

    return (
        <div style={{ marginBottom: "16px", width: "100%" }}>
            {/* Label */}
            <label
                style={{
                    display: "block",
                    marginBottom: "2px",
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#0F2A44",
                }}
            >
                {label}
                {required && <span> *</span>}
            </label>

            {/* Input / Textarea */}
            {fieldType === "textarea" ? (
                <textarea
                    {...field}
                    {...props}
                    placeholder={placeholder}
                    style={{
                        width: "100%",
                        minHeight: "80px",
                        padding: "8px 10px",
                        border: "1px solid #9E9E9E",
                        borderRadius: "2px",
                        fontSize: "14px",
                        outline: "none",
                    }}
                />
            ) : (
                <input
                    {...field}
                    {...props}
                    ref={inputRef}
                    type={fieldType}
                    placeholder={placeholder}
                    autoComplete="off"
                    onClick={handleInputClick}
                    style={{
                        width: "100%",
                        height: "38px",
                        padding: "8px 10px",
                        border: "1px solid #9E9E9E",
                        borderRadius: "2px",
                        fontSize: "14px",
                        outline: "none",
                    }}
                />
            )}

            {/* Error */}
            {meta.touched && meta.error && (
                <div className="error">{typeof meta.error === "string" ? meta.error : meta.error?.value}</div>
            )}
        </div>
    );
}

export default TextInput;
